// en.js
export default {
  // nav: {
  //   home: "HOME",
  //   products: "PRODUCTS",
  //   solution: "SOLUTION",
  //   about_us: "ABOUT US",
  //   contact_us: "CONTACT US",
  //   language: "LANGUAGE"
  // },
  navArr:[
    {
      title: "HOME",
      path: "/pc/home",
      children:[],
    },
    {
      title: "PRODUCTS",
      path: "/pc/productList",
      children:[
        {
          title:'Recording and Broadcasting Products',
          children:[
            {
              title:'Normalized Recording and Broadcasting',
              img:{
                path:'/pc/productList_info?ID=PECORDED_10',
                src:'record0.png'
              }
            },
            {
              title:'Portable Recording and Broadcasting',
              img:{
                path:'/pc/productList_info?ID=PECORDED_11',
                src:'record1.png'
              }
            },
            {
              title:'4K Recording and Broadcasting',
              img:{
                path:'/pc/productList_info?ID=PECORDED_12',
                src:'record2.png'
              }
            },
            {
              title:'Outdoor Recording and Broadcasting',
              img:{
                path:'/pc/productList_info?ID=PECORDED_13',
                src:'record3.png'
              }
            },
            {
              title:'Practical Training Recording and Broadcasting',
              img:{
                path:'/pc/productList_info?ID=PECORDED_14',
                src:'record4.png'
              }
            }
          ]
        },
        {
          title:'Touch Display',
          children:[
            {
              title:'IR Touch Display',
              img:{
                path:'/pc/productList_info?ID=PECORDED_20',
                src:'smart0.png'
              }
            },
            {
              title:'IR Premuim Touch Diaplay',
              img:{
                path:'/pc/productList_info?ID=PECORDED_21',
                src:'conference-display.jpg'
              }
            }
          ]
        },
        {
          title:'Intelligent Blackboard',
          children:[
            {
              title:'5PLUS Smart Blackbard',
              img:{
                path:'/pc/productList_info?ID=PECORDED_30',
                src:'wisdom0.png'
              }
            },
            {
              title:'Dual-screen Smart Blackboard',
              img:{
                path:'/pc/productList_info?ID=PECORDED_31',
                src:'dual-screen.jpg'
              }
            }
          ]
        },
        {
          title:'Smart Lectern',
          children:[
            {
              title:'Smart Lectern',
              img:{
                path:'/pc/productList_info?ID=PECORDED_40',
                src:'desk0.png'
              }
            },
            {
              title:'Electric Smart Lectern',
              img:{
                path:'/pc/productList_info?ID=PECORDED_41',
                src:'desk1.png'
              }
            }
          ]
        }
      ]
    },
    {
      title: "SOLUTION",
      path: "/pc/schemeList",
      children:[
        {
          title:'4K Video Recording Classroom Solution',
          children:[],
          img:{
            path:'/pc/4k-record',
            src:'1.jpg'
          }
        },
        {
          title:'Normalized Video Recording Solution',
          children:[],
          img:{
            path:'/pc/normalized-record',
            src:'2.jpg'
          }
        },
        {
          title:'Co-teaching Classroom Solution',
          children:[],
          img:{
            path:'/pc/dual-teacher',
            src:'3.jpg'
          }
        },
        {
          title:'Portable Video Recording Solution',
          children:[],
          img:{
            path:'/pc/portable-record',
            src:'4.jpg'
          }
        },
        {
          title:'AI Behavioral Analysis',
          children:[],
          img:{
            path:'/pc/ai-behavior',
            src:'5.jpg'
          }
        },
        {
          title:'Smart Classroom Solution',
          children: [
            {
              title:'Smart Classroom Solution for High Education',
              img:{
                path:'/pc/higherEdu',
                src:'6.jpg'
              }
            },
            {
              title:'K12 All-subject Smart Classroom Solution',
              img:{
                path:'/pc/smartClasssroom',
                src:'7.jpg'
              }
            }
          ]
        },
      ],
    },
    {
      title: "ABOUT US",
      path: "/pc/about_us",
      children:[],
    },
    {
      title: "CONTACT US",
      path: "/pc/contact_us",
      children:[],
    },
  ],
  foot: {
    foot_title: "GET CONNECTED WITH US",
    company: "Company",
    about_wenxiang: "AboutWenXiang",
    awards: "Awards",
    contact_us: "CONTACT US",
    news_events: "News & Events",
    blogs: "Blogs",
    customer_stories: "Customer Stories",
    input_placeholder: "Enter your E-mail Address",
    submit: "SUBMIT",
    details:
      "Sign up to receive WENXIANG marketing emails. You canmodify your subscription or unsubscribe at any time",
    web:'Web Policy',
    product:'Product Policy',
    cookie:'Cookies Policy',
    },
  home: {
    product: "PRODUCT",
    solution: "SOLUTIONS",
    more_btn: "MORE",
    learn_more_btn:"LEARN MORE",
    product_a_title: "SMART BLACKBOARD",
    product_b_title: "INTERACTIVE EDUCATION DISPLAY",
    product_c_title: "RECORD AND BROADCASTING EQUIPMENT",
    slogan: "Building a Beautiful Campus with Information \n Technology and Artificial Intelligence",
    solution_a_title: "4K Record and Broadcasting Classroom",
    solution_b_title: "Normalized Record and Broadcasting Classroom Construction Program",
    solution_c_title: "Co-teaching Classroom Solution",
    solution_d_title: "Portable Record and Broadcasting Construction Program",
    solution_e_title: "AI Intelligent Behavior Analysis",
    solution_f_title: "Smart Classroom Overall Solution for Higher Education",
    },
  contact_us: {
    contact_us: "CONTACT US",
    contact_details:
      "Building a Beautiful Campus with Information Technology \n and Artificial Intelligence",
    contact_BJ_title: "Beijing Wenxiang Information \n Technology Co., Ltd.",
    contact_BJ_itemA:
      "Add: 11/F, Tower B, No.15 Ronghua South Road, Beijing Economic-Technological Development Area, Beijing, China",
    contact_BJ_itemB: "Web: http://www.wenxiang.cn",
    contact_BJ_itemC: "Tel: 010-81028190/91/92/93/94",
    contact_BJ_itemD: "Service Hotline: 400-860-8282",
    contact_AH_title: "Anhui Wenxiang Technology \n Co., Ltd.",
    contact_AH_itemA:
      "Add: Intersection of Fengming Avenue and Hanjiang Road, Jiangnan Industrial Concentration Zone, Chizhou, Anhui Province, China",
    contact_AH_itemB: "Web: http://www.wenxiang.cn",
    contact_AH_itemC: "Tel: 0566-5228888",
    contact_AH_itemD: "Service Hotline: 400-860-8282"
  },
  about_us: {
    about_us: "ABOUT US",
    about_details:
      "Building a Beautiful Campus with Information Technology \n and Artificial Intelligence",
    company_profile: "Company Profile",
    BJ_company_profile_title: "BEIJING WENXIANG",
    BJ_company_profile_details:`
    Beljing Wenxiang lnformation Technology Co, Ltd. (referred to as Beijing Wenxiang) is an information technology companyspecializing in video and audio acquisition and transmission, image recognition and deep learming, big data mining and application. Among them, the core technologies of intelligent recording and broadcasting and teaching behavior identifcation andanalysis independently developed by Wenxiang are at the international leading level.At present,Wenxiang has obtained 316 authorized patents and has 252 software copyrights. As a technological innovation enterprise, Wenxiang has always adhered to the source of core technology innovation, and its hardware and software integrated inteligent products have been widely used in the field of education informatization, providing perfect and high-quality solutions for education. The main products include automatic recording and broadcasting system, teaching behavior identifcation and analysis system, smart management system, intelligent teaching system, education big data platform. Adhering to the purpose of Use IT and l to Build a Better Campus, Beling Wenxiang is wiling to work together with our partnersto make contributions to the realization of education balance and education informatization with more cuting-edge technology.more advanced products and better services.`,
    AH_company_profile_title: "ANHUI WENXIANG",
    AH_company_profile_details:
      "Anhui Wenxiang Technology Co.,Ltd. (referred to as Wenxiang) is an education information technology enterprise with core intellectual property rights that is committed to promoting the in-depth integration of information technology and education and teaching, and bringing the new generation of information technology and artificial intelligence to every teacher and student, every classroom and school, so that information technology can serve for a better education, and education can promote the continuous development of information technology. Wenxiang has successively set up several branches around the world.Focusing on the overall solutions of intelligent campuses, Wenxiang taking the lead to  the development of ecological chain cluster [Wenxiang Intelligent Industrial Park], can drive hundreds of enterprises to move in, the main positioning of information technology, artificial intelligence, big data, Internet of Things and other emerging industries in the education industry, and gradually form a national intelligent education demonstration base of education informatization, education intelligence and other industrial aggregation."
  },
  productList: {
    title_A: "OUR PRODUCTS",
    title_B: "PECORDED PRODUCTS",
    WIS_DList: [
      "Normalized Record and Broadcasting Equipment",
      "Record and Broadcasting Equipment",
      "4K Record and Broadcasting Equipment",
      "Outdoor Record and Broadcasting Equipment",
      "Full-scene PortableRecord and BroadcastingEquipment"
    ],
    title_C: "SMART <br/>TABLET",
    whiteBoardList: ["Interactive Education Display","Conference Interactive Display"],
    title_D: "WISDOM THE BLACKBOARD",
    blackBoardList: ["5PLUS Smart Blackbard","Dual-screen Smart Blackboard"],
    title_E: "WISDOM <br/> DESK",
    platformList: ["Smart Lectern", "Electric Smart Lecte"]
  },
  product_info: {
    title_A: "OVERVIEW",
    title_B: "FEATURES",
    title_C: "PRODUCT MODELING",

    A_A: {
      title_A: "Normalized Record and Broadcasting Equipment",
      title_A_txt: "HD Multi-touch Screen Built-in Hard Disk.",
      CPJS_txt: ` Wall-mounted design and industrial-grade embedded high-performance video and audio 
        processing chip. 17.3” HD multi- touch screen with built -in hard disk, realizing recording, 
        live broadcasting and interactive.
      `,
      WIS_DList: [
        {
          name: "POE Power Supply",
          conters:
            "Supporting multi-channel POE camera access and integrating power supply, control, and video transmission."
        },
        {
          name: "Touch Control",
          conters:
            "Adopting 17.3” touch LCD screen design with full touch control and video control management."
        },
        {
          name: "Resource Sharing",
          conters:
            "External USB storage devices can be connected, and courseware videos can be copied directly from the portable record and broadcasting equipment. Remote WEB download operations are supported."
        },
        {
          name: "Security and Protection",
          conters:
            "Embedded system and functional software cannot be accessed, modified, deleted or added to any other program by any person or program, avoiding any system damage caused by any wrong operation, and there is no risk of network virus infection"
        }
      ]
    },
    A_B: {
      title_A: "Portable Record and Broadcasting Equipment",
      title_A_txt: `15.6” HD touch screen can realize real-time monitoring 
      andbroadcasting control, which is easy to operate.`,
      CPJS_txt: ` 4G/5G and WiFi network supports online live broadcasting at anytime
        and anywhere. Professional-grade wireless module can automatically
        pair wireless cameras after startup with strong transmission. Built-in
        battery make it more portable to use, and can be quickly set up
        recording and broadcasting scenes.
      `,
      WIS_DList: [
        {
          name: "AI tracking algorithm achieves automatic tracking"
        },
        {
          name: "Built-in AI behavior analysis"
        },
        {
          name: "The touch screen adopts full lamination AG+AF process."
        },
        {
          name:
            "LCD screen with high brightness can meet indoor and outdoor recording needs."
        }
      ]
    },
    A_C: {
      title_A: "4K Record and Broadcasting Equipment",
      title_A_txt: `ingle board design, no delay broadcasting, and multiple 
       concurrent remote control.
        `,
      CPJS_txt: `Wenxiang 4K record and broadcasting equipment adopts single-board
        embedded architecture and ARM+DSP+Linux operating system, which is
        stable and reliable. Completely separating from the Windows system, it
        make users have no worry about whether Microsoft's operating system
        will stop updating or be attacked by other viruses. The system
        integrates video and audio collection, remote broadcast guidance,
        online live broadcast, online on-demand broadcast, interactive
        teaching, 4K recording and other functions. In response to the
        national call for energy conservation and environmental protection,
        Wenxiang 4K record and broadcasting equipment adopts low-voltage DC
        power supply, low energy consumption, and low heat to ensure safe and
        reliable teaching activities.
      `,
      WIS_DList: [
        {
          name: "Interactive Teaching",
          conters: `
          Support RTSP/H.323/SIP and other multi-protocol interaction
          `
        },
        {
          name: "4K UHD Recording",
          conters: `
          4K UHD video recording. Supporting 4K UHD picture synthesis and recording.
          `
        },
        {
          name: "Remote Guidance",
          conters: `
          SSupporting online broadcasting, including multi-channel real-time preview, special effects, screen splicing, 
          camera control and other remote guidance.
          `
        },
        {
          name: "Customized Modification",
          conters: `
          Supporting course information, subtitles, titles, and end information. Supporting setting subtitles to enhance the appeal of courseware.
          `
        },
        {
          name: "Multiple Recording Modes",
          conters: `
          Supporting fully automatic, manual, and semi-automatic control methods, realizing single-stream single-screen (movie mode), 
          single-stream multi-screen, multi-stream multi-screen (resource mode) and other recording modes.
          `
        },
        {
          name: "Security and Protection",
          conters: `
          Embedded system and functional software cannot be accessed, modified, deleted or added to any other program by any person or program, 
          avoiding any system damage caused by any wrong operation, and there is no risk of network virus infection.
          `
        }
      ]
    },
    A_D: {
      title_A: "Outdoor Record and Broadcasting Equipment",
      title_A_txt: `Localization Design Built-in 17.3” Touch Screen One-key Recording.
        `,
      CPJS_txt: `Military localization portable recording and broadcasting equipment
        with Phytium motherboard and Kylin domestic system can meet the
        bidding parameters of localization. Portable design with 4 universal
        wheels is convenient to use.
      `,
      WIS_DList: [
        {
          name: "Domestic Design",
          conters: `
          Phytium motherboard and Kylin domestic system can meet the 
          bidding parameters of localization.
          `
        },
        {
          name: "Portable Design",
          conters: `
          With four universal wheels, the equipment is convenient to use. When the equipment is placed horizontally, 
          the wheels can be collected; And after opening the tripod, the product can be placed horizontally.
          `
        },
        {
          name: "Portable Power Supply",
          conters: `
          The power supply is independent and it can be charged on the hose or can be charged separately.
          `
        },
        {
          name: "Dual-screen Design",
          conters: `
          Office and audio/video application don’t interfere with each other. When users use KyLin System office software, 
          the recording and broadcasting can normally use the audio/video recording, live broadcasting, screen switching and other functions.
          `
        }
      ]
    },
    A_E: {
      title_A: "Training Record and Broadcasting Equipment",
      title_A_txt: `New Model of Demonstration Teaching Integration of Production and
        Teaching.It helps the construction of teachers and concentrates on
        the improvement of students.
        `,
      CPJS_txt: `The whole training movable car is made of sheet metal profile
        material, and equipped with high-quality silent universal wheel at the
        bottom, which can be moved freely to teach. And the recording and
        broadcasting equipment can be hidden and installed in the box.
        Removable battery ensures long hours of teaching and three cameras can
        record the details of teaching. High integration of hardware and
        software is suitable for a variety of teaching scenarios.
      `,
      WIS_DList: [
        {
          name: "Triple-view Design",
          conters: `
          Triple-view design records the teaching close-up picture and full view, and students’ full view in the practical training system.
          `
        },
        {
          name: "Sound Reinforcement",
          conters: `
          Built-in 30W high-quality speaker cooperates with the teacher pickup can make real-time expansion of teaching voice.
          `
        },
        {
          name: "Ultra-long Battery Life",
          conters: `
          High quality power supply with replaceable disassembly design can provide a strong guarantee for continuous teaching.
          `
        },
        {
          name: "Screen Linkage",
          conters: `
          It supports the screen to connect to smart blackboard, interactive intelligent display and other display 
          devices to solve the pain points in traditional teaching and focus on the important points.
          `
        }
      ]
    },
    B_A: {
      title_A: "Interactive Education Display",
      title_A_txt: ` High-definition, Simple and Powerful, Stable and Reliable.
        `,
      CPJS_txt: `Wenxiang new dual-system education display has a unique and simple
        appearance. It has a powerful quad-core chip and a built-in UHD
        large-view camera. Ultra-thin infrared touch design can deeply
        integrate with Wenxiang teaching software, realizing a smoother and
        more efficient teaching.
      `,
      WIS_DList: [
        {
          name: "4K HD Image",
          conters: `
          High brightness make the images more natural, clearer and more transparent.
          `
        },
        {
          name: "HD Camera",
          conters: `
          4K ultra-high-definition(UHD) camera with 13M pixels and wide viewing angle make clear and delicate images.
          `
        },
        {
          name: "Quad-core Upgraded",
          conters: `
          Equipped with quad-core 1.9G HZ chip and Android11.
          `
        },
        {
          name: "Interface Cover Design",
          conters: `
          The interface cover protects the equipment effectively from dust and damage.
          `
        },
        {
          name: "TYPE-C Interface",
          conters: `
          Integrating power supply, data transmission and other functions, the type-c interface saves the 
          cumbersome connection steps and easily realizes many functions, which is convenient and fast.
          `
        },
        {
          name: "Comprehensive Management and Control",
          conters: `
          Touch lock, screen lock, USB lock and application lock are provided for effective protection for device security.
          `
        }
      ]
    },
    B_B:{
      // 会议交互平板
      title_A: "Conference Interactive Display",
      title_A_txt: `Efficiently Record Smart Office  Experience Beauty of Technology`,
      CPJS_txt: `Conference interactive display integrates projector, electronic whiteboard, TV, advertising machine, audio in one and it has writing, annotation, remote video conference, screen transfer and other functions, effectively improves conference efficiency. The display is often used in government, enterprises and institutions, companies, factory conference rooms, media studios, education and training institutions, exhibition halls and other places.`,
      WIS_DList: [
        {
          name: "Multi-touch",
          conters: `ultra-thin and ultra-narrow infrared design more than 20 touch points make accurate writing`
        },
        {
          name: "HD Camera",
          conters: `13MP with wide viewing angle remote pickup`
        },
        {
          name: "Core performance upgrade",
          conters: `quad-core processor Android 11.0`
        },
        {
          name: "Multiple Software Applications",
          conters: `annotation, screen-share, and writing are all contained`
        },
      ]
    },
    C_A: {
      title_A: "5PLUS Smart Blackboard",
      title_A_txt: `  Ultra-thin Design HD Display Seamless Switching.
        `,
      CPJS_txt: `Wenxiang new generation smart blackboard uses ultra-thin anti-glare
        tempered glass to reduce the interference of ambient light and
        improves the clarity of the picture. Built-in "eye care +" mode can
        effectively reduce the effect of blue light and eye fatigue, which
        protects the eyes health. Upgrade quad-core chip makes the system
        smooth significantly improved. And optional HD camera and multi-array
        microphone can achieve all-round teaching. Seamless switching between
        traditional chalkboard and smart blackboard make teachers teach more
        smoothly and more efficient, bringing a new teaching experience.
      `,
      WIS_DList: [
        {
          name: "4K HD Image",
          conters: `
          High brightness make the images more natural, clearer and more transparent.
          `
        },
        {
          name: "Core Upgraded",
          conters: `
          Equipped with a quad-core 1.9G HZ chip and Android11 operating system make the system more smooth.
          `
        },
        {
          name: "2.1 Stereo Speakers",
          conters: `
          2.1 sound channel ensures sound quality clearer and more extraordinary.
          `
        },
        {
          name: "Seamless System Connection",
          conters: `
          Windows and Android operating system can realize quick inter-transmission between files and applications. Both can be added to the desktop
          `
        },
        {
          name: "Enriching Desktop Components",
          conters: `
          It supports quickly add and delete widgets, including weather, greetings, calendars, daily words and more.
          `
        },
        {
          name: "Eye-protection+ Mode",
          conters: `
          New paper-like screen can effectively reduce the eye stimulation and eyesight damage from the electronic equipment, making eyes more comfortable.
          `
        },
        {
          name: "All-round Control",
          conters: `
          It provides effective protection for the security of the equipment by setting the touch, screen, USB and application function.
          `
        },
        {
          name: "HD Camera + Array Mic (optional)",
          conters: `
          13M pixels and wide viewing angle make clear and delicate images. 8 array microphones ensures  every corner of the classroom can record clearly.
          `
        },
        {
          name: "New Doc-scanner (optional)",
          conters: `
          New upgraded 13M HD pixel doc-scanner ensures flexible deployment and efficient teaching.
          `
        }
      ]
    },
    C_B: {
      // 双屏智慧黑板
      title_A: "Dual-screen Smart Blackboard",
      title_A_txt: `Multimedia Integration Education Supports Customization`,
      CPJS_txt: `Smart blackboard is a multimedia integrated teaching platform that perfectly combines traditional blackboard with intelligent teaching system, projector, electronic whiteboard, 4K HD large-screen TV, computer, power amplifier , visualizer (document scanner) and other technologies.
      Various splicing mode can be made according to the scene environment, mainly double splicing. Supports various splicing methods according to the site environment and the double splicing are popular.`,
      WIS_DList: [
        {
          name: "Convenient Design",
          conters: `Separate detachable OPS computers facilitate later upgrades and maintenance.`
        },
        {
          name: "Safe and Eye-protection",
          conters: `4mm tempered glass with round corner aluminum profile edge prevent teachers and students from bumping. It also effectively filters blue light and protects the eyesight. `
        },
        {
          name: "One-click Switch",
          conters: `One button can realize the switch between the chalking writing and touch display. The chalk writing is smooth and the touch operation is sensitive with 4K HD display.`
        },
        {
          name: "Rich Front Interfaces",
          conters: `Dual-channel USB, Android and OPS can be called at any time. HD speakers make excellent sound. And there are rich system function buttons. `
        },
        {
          name: "Wireless IoT",
          conters: `Wireless WIFI signal transmission module supports WIFI hotspot setting and makes it convenient for mobile phones and other wireless devices to connect and interact. The reserved RS232 interface is convenient for the school to make remote control of equipment switching on and off and other operations.`
        },
      ]
    },
    D_A: {
      title_A: "Smart Lectern",
      title_A_txt: `Ergonomic Design Built-in 23.8” 10-point Capacitive Touch Screen
        One-key Control.
        `,
      CPJS_txt: `The main body of the lectern is made of cold-rolled steel plate. The
        desktop is made of anti-static material, which has the characteristics
        of wear resistance, moisture resistance, fire prevention and
        anti-bacteria. The overall streamlined design guarantees
        anti-collision, beauty and simplicity.
      `,
      WIS_DList: [
        {
          name: "High-quality Desktop",
          conters: `
          Anti-static material makes the product wear-resistant, moisture-resistant, fire-proof and anti-bacteria.
          `
        },
        {
          name: "Large Spare Space",
          conters: `
          The mounting position is reserved for 19” equipment.
          `
        },
        {
          name: "Observation Window",
          conters: `
          The observation window of the computer mainframe is reserved on the lectern, so that the computer could be 
          switched on and off normally without opening the case.
          `
        },
        {
          name: "easy teaching",
          conters: `
          The tilting design of the teaching screen displays provides the best angle of view to show the teaching content. 
          The teacher stands at an appropriate position, improving the teaching efficiency. 
          Real-time linkage between large and small screens make teaching more easier.
          `
        }
      ]
    },
    D_B: {
      title_A: "Electric Smart Lectern",
      title_A_txt: `Integrating split-screen teaching system, Wenxiang intelligent
        control system, record and broadcasting system, interactive system,
        tracking system and audio processing system, Wenxiang electric
        lectern can easily realize smart teaching.
        `,
      CPJS_txt: `Smart lectern adopts a three-stage design with aluminum alloy profiles
        as the main body and the surface is treated by sandblasting and
        anodizing process, showing a sense of fashion and technology. The
        lectern integrates control system, record and broadcasting system,
        interactive system, tracking system, and audio processing system to
        easily realize smart teaching.
      `,
      WIS_DList: [
        {
          name: "Multi-screen Linkage Teaching",
          conters: `
          Equipped with high-resolution(HD) electromagnetic dual-mode touch screen and adjustable display screen, 
          the equipment can realize real-time linkage between large and small screens which can make teaching more easier.
          `
        },
        {
          name: "Smart IOT System",
          conters: `
          The 10.1” central control panel can control various terminal devices in the classroom, realizing real-time 
          control of recording, broadcasting, interaction and live broadcasting.
          `
        },
        {
          name: "Multifunctional Design",
          conters: `
          Hidden goose-neck microphones, visualizer, and flip-type multi-function table sockets increase space 
          utilization and improve teachers' teaching efficiency.
          `
        },
        {
          name: "High Integration",
          conters: `
          The central column door design is convenient for equipment installation and maintenance, and it is 
          equipped with a safety lock to ensure safety. The drawer-type cabinet design at the bottom can place 
          record and broadcasting equipment hosts, tracking equipment, etc. in it.
          `
        }
      ]
    }
  },

  // 方案
  // 主页
  homepage: {
    title: "WE OFFER SOLUTIONS",
    list: [
      {
        title: "4K Video Recording Classroom Solution",
        introduce: []
      },
      {
        title: "Normalized Video Recording Solution",
        introduce: []
      },
      {
        title: "Co-teaching Classroom Solution",
        introduce: []
      },
      {
        title: "Portable Video Recording Solution",
        introduce: []
      },
      {
        title: "AI Behavioral Analysis",
        introduce: []
      },
      {
        title: "Smart Classroom Solution",
        introduce: [
          'Smart Classroom Solution for High Education <br/> K12 All-subject Smart Classroom Solution',
        ]
      }
    ]
  },

  // 三个课堂
  three_classRoom: {
    title: "FEATURES AND ADVANTAGES",
    titleOne: "THREE-CLASSROOM",
    titleTwo: "SOLUTION",
    appTitle: "APPLICATION PACKAGE",
    content:
      "The program is suitable for a variety of Program application scenarios such as cross-regional interactive teaching activities, co-construction and sharing of high-quality course resources.",
    contentTwo:
      "This solution is suitable for a variety of scenarios such as sharing master teacher resources, forming online teaching and research, teaching level assessment, teaching observation and evaluation, and educational outreach.",
    contentThree:
      "This solution is suitable for a variety of scenarios such as setting up a famous school online classroom portal, synchronous courses, thematic courses, school-specific courses and realizing the display of high-quality courses.",
    synopsisOne:
      "Classroom-to-classroom online construction solution is based on the county and district, giving full play to the radiation role of urban central schools. And it promotes a variety of teaching and teaching and research organization models, helps schools to conduct the state-prescribed curriculum with totally determination, and promotes the fair and balanced development of education.",
    synopsisTwo:
      "To give full play to the role of special-grade teachers, provincial and municipal subject leaders and leading teachers, this solution uses the Wenxiang’s Full-time Education Cloud Platform to help more teachers in the provinces, cities to conduct a series of teaching and research activities. And it will help teachers to break through the bottleneck of professional development and improve the overall quality of education and teaching in schools.",
    synopsisThree:
      "There is an experimental school including schools affiliated to provincial universities, municipalities and key county schools, and it will be set as the teaching subjects. The schools concerned will draw up lesson recording plans, set up recording systems and organize excellent teachers to produce online lessons at the same time. After the reviewing of subject contents and recording technology, high-quality resources will be widely shared.",
    list: [
      "Classroom-to-classroom Online Construction Program",
      "Teacher-to-teacher Online Construction Program",
      "School-to-school Online Construction Program"
    ],

    functionList: [
      "Intelligent Course Recording",
      "Online Remote Live Broadcasting",
      "Two-way Distance Interactive Teaching",
      "Multi-board Writing and Screen Interaction",
      "Visual Management and Remote Guidance",
      "Data Statistics"
    ],

    functionListTwo: [
      {
        title: "Conducting Diversified Web-based Teaching and Research",
        name:
          "With master teachers as the core, we make full use of their resources and vigorously carry out the 1+N application to solve the shortage of outstanding teachers and achieve the sharing of quality educational resources in the region."
      },
      {
        title: "Online Remote Live Broadcasting",
        name:
          "Through the demonstration effect of master teachers, network interactive teaching, excellent lesson recording and remote training can be carried out to realize the network-helping teaching activities. Using the master teachers recorded courses with high-quality at the same time for other classrooms to study and observe the course, which gives full play to the leading role of master teachers."
      },
      {
        title: "Accessibility",
        name:
          "Through the integrated design of teaching, research and training, teachers are helped to carry out teaching and research on the practical problems they encounter in the teaching process, and to reflect on and re-practice their teaching, so as to improve their teaching standards."
      }
    ],

    functionListThree: [
      {
        title:
          "Conducting Public Classroom Activities to Promote Student-led Learning",
        name:
          "By creating a space for high-quality resources, students can selectively participate according to their own situation and learn in fragments. Online classes can build independent learning channels for students."
      },
      {
        title:
          "Expanding the Utilization of High-quality Resources and Exemplary Effect of Prestigious Schools",
        name:
          "The recording system can realize the standardized recording of daily teaching audio and video data combined with digital teaching materials, which are processed to form high-quality lessons and micro-lessons that teachers can upload and share on the school resource management platform. It helps schools to deposit high-quality educational resources, complete the construction of school-based resources, expand the utilization rate of high-quality resources and bring into play the demonstration effect of prestigious schools."
      },
      {
        title: "Promoting Personalized Development of Students",
        name:
          "Once completed, the online classroom can be opened to the public to create a high-quality curriculum with high-quality resources from the region's famous schools. It definitely thus builds a self-learning channel for students, facilitates fragmented and independent learning and promotes their personalized development."
      }
    ]
  },

  // 中小学全学科智慧教室建设方案
  mediumSchool: {
    title:
      "K12 ALL-SUBJECT SMART CLASSROOM CONSTRUCTION PROGRAM",
    content:
      "Wenxiang Smart Classroom is an innovative classroom with service teaching as the core. It is a set of solutions that realize all-media, all-coverage, all-linkage and interactive integration. It covers all teaching links during the teaching process, and it also can optimize teaching content, promote classroom interaction, and get convenient access to teaching resources. At the same time, it has the situational awareness and can take environmental intelligent management and control, achieving a healthy, intelligent, environmentally friendly and efficient new classroom teaching mode.",
    componentsTitle:'PROGRAM COMPONENTS',
    components:[
      'smart blackboard','smart lectern','recording system','learning behaviour analysis system','smart management','integrated design'
    ],
    features_title:'FEATURES AND ADVANTAGES',
    featuresList: [
      {
        title: "Smart Blackboard",
        name:'Wenxiang smart blackboard integrates traditional blackboard, intelligent teaching system, multi-touch, HD LCD display, amplifier, speaker and other technologies. Through the five-finger screen technology, teachers can easily switch seamlessly between the traditional blackboard and the interactive display system, complete ordinary blackboard writing, electronic whiteboard interaction, teaching resource invocation, multimedia courseware demonstration and other operations.'
      },
      {
        title: "Anti-glare and Eye-protection",
        name:'The surface of the glass adopts nano-composite coating technology to filter the harmful light source and effectively protect the eyesight of teachers and students.'
      },
      {
        title: "Dual OS",
        name:"Windows and Android dual system and rich teaching Program application software."
      },
      {
        title: "Multimedia Teaching",
        name:'It comes with interactive whiteboard software and multimedia teaching resources, supporting video, music, pictures, PPT and other multimedia teaching materials.'
      }
    ],
    automatic: {
      title: "Automatic 4K Record and Broadcasting System",
      name:'The classroom contains a fully automatic six-camera recording system, which supports the filming and recording of multiple video channels, including teacher close-ups and full views, student close-ups and full views, writing close-ups and student patrol pictures. All shoots are in high quality, achieving true full HD recording. It also supports access to computer signals for recording. The student walk-through function allows you to take close-ups of each student in real time, forming student behaviour data for later analysis.'
    },
    longEssay: [
      {
        title: "Smart Electronic schoolbag",
        name:
          "It is based on education cloud services and applications, and equipped with smart blackboard, student smart learning terminals and PAD smart classroom system, smart schoolbag can achieve a simple, practical and efficient smart classroom. Teachers can design interactive, collaborative, independent and other diverse classrooms according to the learning statistics of pre-lessons. Teachers can flexibly design the functions of classroom interaction and monitor real-time learning status of students. Also, teachers can interact with classroom materials and questions, reaching question-answering in real time, and provide targeted explanations and comments. The system focus on process assessment and the ability and attitude of students’ learning, motivates them to learn, reduces their stress, develops positive learning attitude and improves their performance."
      },
      {
        title:
          "Interactive classroom and pre-class cloud preparation seamlessly integrated",
        name:
          "Before class, teachers can easily prepare lessons using the precise resources in the Education Cloud platform, and send the preparation content to the class that needs to be taught with a single click, and get the preparation materials directly from the cloud after logging into the account during class. It also supports teachers to upload preparation resources to the classroom computer in advance, so that classes can be held normally based on the classroom when the external network is unstable or not available. And it doesn’t need to add additional storage devices in the classroom."
      },
      {
        title:
          "One-click question distribution and real-time results evaluated",
        name:
          "Teachers can distribute questions in real time in the classroom, and students receive the questions and choose their answers to submit. The answering situation will be showed to the teachers’ side, including the number of answers, the average correct rate, the distribution of answers, and the details of students' answers."
      },
      {
        title:
          "Real-time monitoring of students' learning process and comprehensive control of students' learning status",
        name:
          "Teachers can use the monitoring function to monitor the learning status of all students in real time. Users can see if the student is online, if it is muted, and can check the current screen information of the student's pad and compare and monitor multiple students' screens at the same time."
      },
      {
        title: "Classroom evaluation",
        name:
          "Teachers can manage current class members individually and in groups, giving multidimensional evaluations to groups or individuals at any time."
      },
      {
        title:"Classroom report",
        name:"A full classroom report is automatically generated, including the percentage of correct knowledge of the lesson, the percentage of correct questions for each question in the classroom exercise, the distribution of options, etc., to help review the content of the lesson."
      },
      {
        title: "Quantifying teaching quality",
        name:"Supervising teachers and students. Integrating online learning space and offline classroom learning space to provide a full range of teaching data analysis services. Helping teachers and researchers to understand the details of teaching and learning, to keep up to date with teaching dynamics and to quantify accurately the quality of classroom teaching. "
      }
    ],
    smartOne: {
      title: "SMART MANAGEMENT SYSTEM"
    },
    smartListOne: [
      {
        title: "Smart Attendance",
        name:
          "Based on deep learning algorithms, the system detects faces in images and performs a series of face-related feature analysis, recognizing multi-dimensional face information including name, position, clock-in time, expression and so on. The system can automatically generate attendance summary reports. For example, the number of people present, the number of people actually present, attendance statistics analysis, etc."
      },
      {
        title: "Intelligent learning analysis",
        name:
          "The system supports AI technology and provides real-time insight into changes in the teaching scene. It can automatically capture and analyse the behavioral activities of students in the room, including the recognition of basic movements and combinations of movements such as head-down, hand-up, head-twist and turn-back, and automatically generate reports. For example: number of hands-raised, number of heads-down, statistical analysis, etc. Through the analysis of classroom student behavior, teachers can understand the learning status of students, improving the development of personalized teaching in schools from single to multiple, closed to open."
      },
      {
        title: "Smart Equipment Control",
        name:'The central control management platform provides remote control, information collection, data analysis, data monitoring, data statistics and fault alarm functions.'
      },
      {
        title: "Centralized Equipment Management and Statistical Analysis of Data",
        name:"Through the Wenxiang Smart Data Platform, the operating status of information equipment in many classrooms can be visually checked and analyzed, including checking multimedia teaching equipment, recording equipment and other information equipment, and visualizing and managing data such as the number of times the equipment is used, the length of time it is used and the area in which it is distributed."
      }
    ],
    countentBox: "Intelligent Environmental Control System",
    countent: [
      {
        name:"Intelligent Eye-protection Lighting Environmental Control System: In order to comprehensively strengthen the prevention and control of myopia in teenagers, the system can recognize the light changes in the space. It will automatically adjust the power of the equipment to ensure that the system runs in the best state and ensure that teachers and students have classes in the healthiest light environment."
      },
      {
        name:"Smart Temperature and Humidity Control System: Based on the real measurements of the environment and the set target parameters, the air conditioning or fan operation is automatically adjusted to control the temperature and humidity of the environment, ensuring a healthy and comfortable environment in the classroom at all times."
      },
      {
        name:"Intelligent Air Quality Control System: The system is mainly composed of CO2 intelligent sensing module, PM2.5/PM10 intelligent sensing module, intelligent cabinet fresh air system and environmental intelligent control terminal, etc. The system solves all aspects of air quality problems in the classroom to ensure the air quality."
      }
    ],
    k12OrHigherEdu: [
      'K12 All-subject Smart Classroom Solution',
      'Smart Classroom Solution for High Education',
    ],
  },

  //智能录制和广播解决方案
  intelligentRecord: {
    title:
      "BUILDING A BEAUTIFUL CAMPUS WITH INFORMATION TECHNOLOGY AND ARTIFICIAL INTELLIGENCE",
    titleOne: "INTELLIGENT RECORD AND BROADCASTING",
    titleTwo: "SOLUTION",
    bottomBox: "APPLICATION PACKAGE",
    threeBox:
      "The essence of micro-teaching course production is described in short, small, precise and professional.",
    easeTitle: "EASE OF USE",
    easeCount:
      "Ease of use is comprehensive and multi-layered. It can be segmented into user roles for a perfect experience.",
    bottomTitle:
      "The case consists of record and broadcasting equipment, image tracking all-in-one equipment, camera, smart blackboard, audio acquisition system, recording and broadcasting control system, teaching resource management platform and other products.",
    bottomTwoTitle:
      "The program is widely used in a variety of applications such as record and broadcasting classroom resource construction, teaching quality assessment, classroom monitoring system, safe campus and so on.",
    bottomThreeTitle:
      "This solution is widely used in a variety of application scenarios such as micro-class production, flipped classroom, and mobile learning.",
    bottomFourTitle:
      "This solution is applied to a variety of application scenarios such as the construction of teaching resources in schools, the promotion of teacher-student communication, and the balanced development of high-quality educational resources.",
    synopsis:
      "The 4K record and broadcasting classroom is built for recording high-quality courses, which can well reflect the unique teaching methods and advanced education concepts of the teachers. The system adopts multi-camera shooting to intelligently track and switch the video images of teachers teaching, students listening to lectures, teacher-student interaction scenes and classroom blackboard content. It is effective and necessary to create and disseminate excellent courses by recording classroom activities.",
    synopsisTwo:
      "The program supports the construction of teaching video resources by means of information technology, realizes large-scale cross-platform interaction, live broadcasting, on-demand and other Program applications. And it has centralized management, remote control, online course patrol and other functions, enhancing the utilization rate and coverage of information teaching equipment. It also can help schools to carry out teaching work such as making teaching video courses, evaluating teachers' teaching ability, remote observation, comments and academic exchanges, teaching research and helping and assisting teaching, which can let more excellent teaching resources be made and shared together.",
    synopsisThree:
      "Micro-teaching refers to the whole process of teaching around single or multiple knowledge points in the teaching process recorded by video as the main carrier. The classroom video clips and other auxiliary teaching resources related to the teaching theme including teaching design, materials, teaching reflections, practice tests, student feedback, teacher comments, consist its core components of micro-class. The whole contents organizes and presents in a certain way to create a semi-structured, simple and They are organized and presented in a certain way to create a semi-structured, simple and thematic small environment for the application of knowledge units.",
    synopsisFour:
      "At present, China is comprehensively promoting Internet+education mode, relying on the advantages of the Internet and other information technology, innovating school twinning support mechanism, and promoting the common construction and sharing of high-quality educational resources, to expand the radiation of high-quality educational resources, and realize the management of mutual aid schools, teaching and research, resource sharing, information sharing, teacher-student interaction, and complementary differences. At the mode, there are two teachers. One lecturer teacher teaches online, the other teacher manages students on site in the classroom on the listening side offline. This teaching mode gives full play to the advantages of both online and offline teachers and effectively improve the classroom efficiency and teaching quality, enabling students from different regions to enjoy the same quality education resources. Now, the remote dual-teacher classroom solution has been well received by schools and training institutions.",
    synopsisFive:
      "The rapid development of the Internet, AI, big data, 5G and other technologies has brought significant impact on education and teaching. Wenxiang is actively applying new information technology to innovate teaching organization mode, improve learning environment, develop digital education resources, accelerate the construction and application of intelligent learning environment, enhance the innovative ability of informationized teaching, and promote the deep integration of information technology and teaching. Based on this, Wenxiang launched a portable record and broadcasting construction solution, which adopts full wireless transmission technology and can be set up in 3 minutes, so that recording and broadcasting can be truly mobile and no longer restricted by the site environment. It realizes high-quality course resource production and relay, academic video presentation and conference, large-scale live streaming of course video, and distance education, and etc..",
    list: [
      "4K RECORD AND BROADCASTING CLASSROOM CONSTRUCTION PROGRAM",
      "NORMALIZED RECORD AND BROADCASTING CLASSROOM CONSTRUCTION PROGRAM",
      "PORTABLE RECORD AND BROADCASTING CONSTRUCTION PROGRAM",
      "MICRO-TEACHING ROOM CONSTRUCTION PROGRAM",
      "REMOTE DUAL-TEACHER CLASSROOM CONSTRUCTION PROGRAM"
    ],

    featuresList: [
      {
        title: "Safe and Stable",
        name:
          "All core devices are all adopts built-in DSP+ARM design based on Linux system, which has the characteristic of high stability, low consumption and maintenance-free."
      },
      {
        title: "Fully Automated Operation",
        name:
          'It supports automatic image tracking and screen switching, which lets the teacher focus on the teaching itself. The teacher can start classroom recording by "one-click". HD shooting, and professional audio acquisition and processing helps the entire teaching process for HD recording.'
      },
      {
        title: "AI Technology",
        name:
          'Based on a variety of AI technologies such as "teacher identity recognition", "face recognition" and "image intelligent recognition", Wenxiang has realized Program applications such as teacher height adaptive and speaker identity automatic recognition.'
      },
      {
        title: "New Automatic Tracking Mode",
        name:
          "The two tracking modes of group interaction and student listening behavior inspection are developed and designed according to the current popular group teaching mode, which can realize the automatic tracking and guidance of new teaching modes such as maker practice teaching, group class and future class."
      }
    ],

    featuresListTwo: [
      {
        title: "Simple Design",
        name:
          "Minimalist design supports wall-mounted installation, and does not take up classroom space."
      },
      {
        title: "All in one",
        name:
          "One normalized record and broadcasting equipment integrates the functions of multiple devices such as touch record and broadcasting host and remote interactive host, making the record and broadcasting device no longer be cumbersome."
      },
      {
        title: "High Performance and Ultra Stable",
        name:
          "The equipment adopts single-board design and built-in embedded system, supporting concurrent processing of multi-channel audio and video signals with strong performance, strong stability and durability."
      },
      {
        title: "4K Ultra HD Image Quality",
        name:
          "The camera uses 4K ultra-high-definition imaging technology, video analysis technology and electronic PTZ technology to make video shooting clearer and image tracking more accurate. And at the same time, it can achieve a single-dual scene, achieving 4 automatic tracking and switching by two cameras shoot, including teacher close-up and full view, student close-up and full view. The whole process without manual intervention provides a new recording experience and professional video effects."
      }
    ],

    featuresListThree: [
      {
        title: "Embedded Single-board Design",
        name:
          "Embedded single-board structure, and Linux system protect Windows from updates and viruses. The embedded architecture can also reduce the failure rate of the equipment. The power supply only needs 24V, which is low power consumption and low heat generation."
      },
      {
        title: "HD Audio Acquisition",
        name:
          "The audio signal of the instructor is picked up through the ceiling pickup microphone or collar microphone. The digital audio matrix processor performs noise reduction and audio equalization on the ambient sound to optimize the audio recording effect."
      },
      {
        title: "Easy and Automatic Operation",
        name:
          "With the control buttons on the micro-teaching panel, teachers can quickly start micro-teaching recording operations such as start, pause, pause, and live streaming. Once recording is completed, the video files can be automatically uploaded to the server with a single click, reducing redundant operations for teachers."
      },
      {
        title: "Online Video-editing",
        name:
          "Users can merge, edit and convert the video resources after login the resource management platform without downloading any client base. The edited videos can be uploaded to the resource management platform for sharing, which is convenient for students to learn."
      }
    ],

    featuresListFour: [
      {
        title: "3-minute Fast Installing",
        name:
          "Built-in embedded system can realize live streaming, on-demand and recording without plug-in. The whole installation of this system can be set up by simply selecting the location of the equipment and connecting the HD camera, portable record and broadcasting equipment, microphone and other accessories correctly. The whole system is easy to set up, which can be completed in 3 minutes, reducing the cumbersome operation steps and labor costs."
      },
      {
        title: "Portable and Easy Anytime and Anywhere",
        name:
          "The portable recording system is designed for temporary recording situations, with simple structure and easy movement. There is no need to set up a fixed recording classroom and it greatly saves the cost of users and realizes recording be finished at anywhere and anytime. The whole set of equipment can be easily carried by one person with designed fight case, and it is easy to move and record without any restrictions on location."
      },
      {
        title: "Guide Functions",
        name:
          "The guide function of the equipment is mainly used in the course of recording multiple scenes and multiple video signal sources, video/audio files and computer screen switching between."
      },
      {
        title: "Large Scale Live Streaming",
        name:
          "The device only needs to connect to the wireless network or mobile-phone hotspot. Then the program screen can be pushed to the whole network live streaming, and can automatically generate the live QR code, viewers can scan to watch the webcast."
      }
    ],

    featuresTwoList: [
      {
        title: "Remote Interaction",
        name:
          "It supports remote interaction and achieves cross-regional interactive teaching, visual network teaching and research and other remote interactive application mode."
      },
      {
        title: "Diversified Program Application Guide Management",
        name:
          "The equipment integrates video and audio acquisition, B/S web remote broadcasting, localized broadcasting, real-time recording, online live broadcasting, online on-demand, tracking and switching, equipment management and other Program application function, realizing simple operation and ensuring efficiency. In addition to computers, users can also log in to the platform through various mobile terminals, which breaks the restrictions of time and space."
      },
      {
        title: "Visual Educational Management",
        name:
          "The platform can carry out centralized control and unified management of each recording and broadcasting classroom, realizing equipment management, remote monitoring, online inspection, unsupervised examination and other Program applications. It provides visual teaching supervision and management platform for educational administrators."
      },
      {
        title: "Smart Docking Course Schedule",
        name:
          "Video automatically classified and stored, and resource management platform can be seamlessly connected with the school educational administration management system curriculum, which is easy to achieve automatic video release and archiving, forming a dynamic update of teaching resources."
      }
    ],

    featuresTwoListTwo: [
      {
        title: "Students",
        name:
          "It provides feedback on learning and carry out adaptive learning."
      },
      {
        title: "Teachers",
        name:
          "The system interface has been streamlined and optimized according to the actual use frequency of teachers, ensuring that teachers can easily get started like operating personal tablets, which ensures the accuracy of operation and let teachers focus on the teaching itself at the same time."
      },
      {
        title: "Audiovisual education administrator",
        name:
          "The product is highly integrated in design, making it easier to manage and maintain while reducing the failure rate."
      },
      {
        title: "School leaders",
        name:
          "It provides teaching information and data, comprehensively analyzes and scientifically grasp teaching status."
      }
    ],

    featuresThreeList: [
      {
        title: "Short",
        name:
          "The recording of high-quality micro-teaching video is generally produced for 5~8 minutes."
      },
      {
        title: "Small",
        name:
          "short time and small resource capacity ensure the quality of audio and video, and it is suitable for the dissemination and sharing of the mobile Internet era."
      },
      {
        title: "Precise",
        name:
          "The teaching content is concise, and it mainly highlights the essence of knowledge points."
      },
      {
        title: "Professional",
        name: "It has real-time and professional targeted knowledge points."
      }
    ],

    featuresFiveList: [
      {
        title: "Easy Operation",
        name:
          "The system is easy to operate and instructor do not have to change their original teaching habits."
      },
      {
        title: "Multi-point Interaction",
        name:
          "The system integrates multiple off-site classrooms into a teaching community, forming a cross-regional cloud classroom and achieving 1+N face-to-face online communication."
      },
      {
        title: "Smooth HD Experience",
        name:
          "The remote dual-teacher classroom solution uses new audio and video coding technology and supports a variety of interactive protocols to ensure that the audio and video interaction is clear and smooth."
      },
      {
        title: "Self-adapting to Complex Network",
        name:
          "It has advanced system algorithm, forward error correction(FEC) technology, frame loss compensation algorithm and Jitter buffering technology. Self-adaptive network and strong anti-packet loss capacity (more than 30%) guarantee low latency, clearness and smooth. And audio and video interaction effect is excellent. In the case of poor school network, the audio and video interaction can be carried out normally."
      },
      {
        title: "Real-time Analysis of Dual-teacher Classroom Data",
        name:
          "Comprehensive analysis of global data, including the number of online users and new users, the number of class sessions, classroom information (packet loss records/network latency records/network bandwidth/CPU utilization rate), etc. The platform analyzes the acquired data and presents it in a clear chart, which is easy for users to visualize and control."
      }
    ],

    featuresFiveListOne: [
      {
        title: "Easy Operation",
        name:
          "The system is easy to operate and instructor do not have to change their original teaching habits."
      },
      {
        title: "Multi-point Interaction",
        name:
          "The system integrates multiple off-site classrooms into a teaching community, forming a cross-regional cloud classroom and achieving 1+N face-to-face online communication."
      },
      {
        title: "Smooth HD Experience",
        name:
          "The remote dual-teacher classroom solution uses new audio and video coding technology and supports a variety of interactive protocols to ensure that the audio and video interaction is clear and smooth."
      },
      {
        title: "Self-adapting to Complex Network",
        name:
          "It has advanced system algorithm, forward error correction(FEC) technology, frame loss compensation algorithm and Jitter buffering technology. Self-adaptive network and strong anti-packet loss capacity (more than 30%) guarantee low latency, clearness and smooth. And audio and video interaction effect is excellent. In the case of poor school network, the audio and video interaction can be carried out normally."
      },
      {
        title: "Real-time Analysis of Dual-teacher Classroom Data",
        name:
          "Comprehensive analysis of global data, including the number of online users and new users, the number of class sessions, classroom information (packet loss records/network latency records/network bandwidth/CPU utilization rate), etc. The platform analyzes the acquired data and presents it in a clear chart, which is easy for users to visualize and control."
      }
    ],

    featuresFiveListTwo: [
      {
        title: "Network Courseware Production",
        name:
          "The system can automatically generate network courseware for network on-demand, which can be edited for deletion, synthesis, indexing, etc. It can also be imported into non-editing platform for professional editing. It is convenient for users to teach and learn comprehensive applications, high-quality courseware evaluation, etc."
      },
      {
        title: "Construction of High-quality Course Resource Library",
        name:
          "It can conduct a high-quality course resource library and provide an open management platform for schools to upload courseware."
      },
      {
        title: "Micro-teaching Assessment",
        name:
          "According to the needs of schools and the characteristics of micro-teaching, Wenxiang embeds the micro-teaching evaluation system in the recording system. Schools can evaluate the technical indicators in the system. And the content of the technical indicators can be modified according to the actual situation of the school. Objective and comprehensive evaluation of teachers' teaching skills can be reached through remote which can also train teachers various teaching skills and thus improve the teaching level."
      },
      {
        title: "Distance Learning Application",
        name:
          "Users can conduct live webcast and after-class on-demand, demonstration teaching, remote learning for students, and remote interactive teaching through the record and broadcasting system. Users can observe and learn at anytime and anywhere without any restriction."
      },
      {
        title: "Recording of Expert Lectures and Important Conferences",
        name:
          "Portable record and broadcasting system can truly realize all-round recording, which can record the whole process of various meetings, and the resources can be saved permanently, which can facilitate users to inquire and play the data after the meeting. The portable recording system is extremely suitable for various temporary meetings, lectures and training occasions."
      }
    ]
  },

  // 高教案例
  higherEdu: {
    title: "SMART CLASSROOM CONSTRUCTION PROGRAM (HIGHER EDUCATION)",
    content:"Wenxiang Smart Classroom is an innovative classroom with teaching services at its core. It is a set of solutions that achieves full media, full coverage, full linkage and interaction, covering all teaching aspects before, during and after class. It can optimize the presentation of teaching content, promote the implementation of classroom interaction and ease the convenience of access to teaching resources. It also have functions such as situational awareness and intelligent control of the environment, which realizing a new classroom teaching mode that is healthy, intelligent, environmentally friendly and efficient.",
    componentsTitle:'PROGRAM COMPONENTS',
    components:[
      'smart blackboard','electric smart lectern','recording system','learning behaviour analysis system','smart management','integrated design'
    ],
    features_title:'FEATURES AND ADVANTAGES',
    featuresList: [
      {
        title: "Smart Blackboard",
        name:
          "Wenxiang smart blackboard integrates traditional blackboard, intelligent teaching system, multi-touch, HD LCD display, amplifier, speaker and other technologies. Through the five-finger screen technology, teachers can easily switch seamlessly between the traditional blackboard and the interactive display system, complete ordinary blackboard writing, electronic whiteboard interaction, teaching resource invocation, multimedia courseware demonstration and other operations."
      },
      {
        title: "Eye Protection",
        name:
          "The glass surface of the Smart Blackboard uses a nano-composite coating process to filter out harmful light sources and effectively protect the eyesight of teachers and students."
      },
      {
        title: "Dual-system",
        name:
          "Windows and Android system platform enriches teaching applications."
      },
      {
        title: "Multimedia Teaching",
        name:
          "It comes with interactive whiteboard software and multimedia teaching resources, supporting various multimedia teaching materials such as video, music, pictures and PPT."
      }
    ],
    explanationList: [
      {
        title: "Intelligent Automatic 4K Recording",
        name:
          "The classroom contains a fully automatic six-camera recording system, which supports the filming and recording of multiple video channels, including teacher close-ups and full views, student close-ups and full views, writing close-ups and student patrol pictures. All shoots are in high quality, achieving true full HD recording. It also supports access to computer signals for recording. The student walk-through function allows you to take close-ups of each student in real time, forming student behaviour data for later analysis."
      },
      {
        title: "Group Interaction Teaching Brings Flipped Classroom",
        name:
          "It provides an open and free teaching space and information-based teaching tools for teachers and students, and it changes from teacher-centred to student-centred and achieves innovation and reform of teaching methods. Students can join group discussions quickly and independently in a active and great classroom where applications such as screen sharing, dynamic previews and dynamic annotations can be used to. Students will increase their learning interest and deepen knowledge understanding."
      }
    ],
    explanationTitle:'SMART MANAGEMENT',
    explanationFourList: [
      {
        title: "Smart Management System",
        name:
          "Smart Attendance: Based on deep learning algorithms, the system detects faces in images and performs a series of face-related feature analysis, recognizing multi-dimensional face information including name, position, clock-in time, expression and so on. The system can automatically generate attendance summary reports. For example, the number of people present, the number of people actually present, attendance statistics analysis, etc."
      },
      {
        title: "Intelligent learning analysis",
        name:
          "Intelligent learning analysis: The system supports AI technology and provides real-time insight into changes in the teaching scene. It can automatically capture and analyse the behavioral activities of students in the room, including the recognition of basic movements and combinations of movements such as head-down, hand-up, head-twist and turn-back, and automatically generate reports. For example: number of hands-raised, number of heads-down, statistical analysis, etc. Through the analysis of classroom student behavior, teachers can understand the learning status of students, improving the development of personalized teaching in schools from single to multiple, closed to open."
      },
      {
        title: "Smart Equipment Control",
        name:
          "The central control management platform provides remote control, information collection, data analysis, data monitoring, data statistics and fault alarm functions."
      },
      {
        title: "Centralized Management and Statistical Analysis",
        name:
          "Through the Wenxiang Data Platform, the operating status of information equipment in many classrooms can be visually checked and analyzed, including checking multimedia teaching equipment, recording equipment and other information equipment, and visualizing and managing data such as the number of times the equipment is used, the length of time it is used and the area in which it is distributed. "
      }
    ],
    controlSystemsTitle: 'SMART ENVIRONMENT CONTROL SYSTEM',
    controlSystem:[
      {
        name:"Smart Eye-protection Light Environment Control System: In order to comprehensively strengthen the prevention and control of myopia in teenagers, the light environment control system will recognize the light changes in the space and automatically adjust the power of the equipment to ensure that the system runs in the best state and ensure that teachers and students have classes in the healthiest light environment."
      },
      {
        name:"Smart Temperature and Humidity Control System: Based on the real measurements of the environment and the set target parameters, the air conditioning or fan operation is automatically adjusted to control the temperature and humidity of the environment, ensuring a healthy and comfortable environment in the classroom at all times."
      },
      {
        name:"Smart Air Quality Control System: The system is mainly composed of CO2 intelligent sensing module, PM2.5/PM10 intelligent sensing module, intelligent cabinet fresh air system and environmental intelligent control terminal, etc. The system solves all aspects of air quality problems in the classroom to ensure the air quality."
      }
    ]
  },
  // 常态化录播
  normalizedRecord:{
    title:"NORMALIZED RECORD AND BROADCASTING CLASSROOM CONSTRUCTION PROGRAM",
    content:"The program supports the construction of teaching video resources by means of information technology, realizes large-scale cross-platform interaction, live broadcasting, on-demand and other Program applications. And it has centralized management, remote control, online course patrol and other functions, enhancing the utilization rate and coverage of information teaching equipment. It also can help schools to carry out teaching work such as making teaching video courses, evaluating teachers' teaching ability, remote observation, comments and academic exchanges, teaching research and helping and assisting teaching, which can let more excellent teaching resources be made and shared together.",
    componentsTitle:'PROGRAM COMPONENTS',
    components: ['smart blackboard','normalized record and <br/>broadcasting equipment','teacher’s <br/>cloud mirror camera','student’s <br/>cloud Mirror camera','omnidirectional pickup','resource management <br/> platform'],
    features_title:'FEATURES AND ADVANTAGES',
    featuresList:[
      {
        title:'Simple Design',
        name:'Minimalist design supports wall-mounted installation, and does not take up classroom space.',
      },
      {
        title:'All in one',
        name:'One normalized record and broadcasting equipment integrates the functions of multiple devices such as touch record and broadcasting host and remote interactive host, making the record and broadcasting device no longer be cumbersome.',
      },
      {
        title:'High Performance and Ultra Stable',
        name:'The equipment adopts single-board design and built-in embedded system, supporting concurrent processing of multi-channel audio and video signals with strong performance, strong stability and durability.',
      },
      {
        title:'4K Ultra HD Image Quality',
        name:'The camera uses 4K ultra-high-definition imaging technology, video analysis technology and electronic PTZ technology to make video shooting clearer and image tracking more accurate. And at the same time, it can achieve a single-dual scene, achieving 4 automatic tracking and switching by two cameras shoot, including teacher close-up and full view, student close-up and full view. The whole process without manual intervention provides a new recording experience and professional video effects.',
      },
    ],
    easeOfUse:{
      title:'Ease of Use',
      name:'Ease of use is comprehensive and multi-layered. It can be segmented into user roles for a perfect experience.'
    },
    texts:[
      {name:'Teachers: The system interface has been streamlined and optimized according to the actual use frequency of teachers, ensuring that teachers can easily get started like operating personal tablets, which ensures the accuracy of operation and let teachers focus on the teaching itself at the same time.'},
      {name:'Students: It provides feedback on learning and carry out adaptive learning.'},
      {name:'Audiovisual education administrator: The product is highly integrated in design, making it easier to manage and maintain while reducing the failure rate.'},
      {name:'It provides teaching information and data, comprehensively analyzes and scientifically grasp teaching status.'},
    ]
  },
  // 4k精品录播
  record4k:{
    title:"4K RECORD AND BROADCASTING CLASSROOM CONSTRUCTION PROGRAM",
    content:"The 4K record and broadcasting classroom is built for recording high-quality courses, which can well reflect the unique teaching methods and advanced education concepts of the teachers. The system adopts multi-camera shooting to intelligently track and switch the video images of teachers teaching, students listening to lectures, teacher-student interaction scenes and classroom blackboard content. It is effective and necessary to create and disseminate excellent courses by recording classroom activities.",
    componentsTitle:'PROGRAM COMPONENTS',
    components: [
      'smart blackboard',
      'broadcasting <br/> equipment',
      'image tracking <br/> all-in-one equipment',
      'HD camera',
      'directional <br/> microphone ',
      'desktop touch panel',
      'resource management <br/> platform',
      'digital audio processor'
    ],
    features_title:'FEATURES AND ADVANTAGES',
    featuresList:[
      {
        title:'Safe and Stable',
        name:'All core devices are all adopts built-in DSP+ARM design based on Linux system, which has the characteristic of high stability, low consumption and maintenance-free.',
      },
      {
        title:'Fully Automated Operation',
        name:'It supports automatic image tracking and screen switching, which lets the teacher focus on the teaching itself. The teacher can start classroom recording by "one-click". HD shooting, and professional audio acquisition and processing helps the entire teaching process for HD recording.',
      },
      {
        title:'AI Technology',
        name:'Based on a variety of AI technologies such as "teacher identity recognition", "face recognition" and "image intelligent recognition", Wenxiang has realized Program applications such as teacher height adaptive and speaker identity automatic recognition.',
      },
      {
        title:'New Automatic Tracking Mode',
        name:'The two tracking modes of group interaction and student listening behavior inspection are developed and designed according to the current popular group teaching mode, which can realize the automatic tracking and guidance of new teaching modes such as maker practice teaching, group class and future class. ',
      },
      {
        title:'Remote Interaction',
        name:'It supports remote interaction and achieves cross-regional interactive teaching, visual network teaching and research and other remote interactive application mode.',
      },
      {
        title:'Diversified Program Application Guide Management',
        name:'The equipment integrates video and audio acquisition, B/S web remote broadcasting, localized broadcasting, real-time recording, online live broadcasting, online on-demand, tracking and switching, equipment management and other Program application function, realizing simple operation and ensuring efficiency. In addition to computers, users can also log in to the platform through various mobile terminals, which breaks the restrictions of time and space.',
      },
      {
        title:'Visual Educational Management',
        name:'The platform can carry out centralized control and unified management of each recording and broadcasting classroom, realizing equipment management, remote monitoring, online inspection, unsupervised examination and other Program applications. It provides visual teaching supervision and management platform for educational administrators.',
      },
      {
        title:'Smart Docking Course Schedule',
        name:'Video automatically classified and stored, and resource management platform can be seamlessly connected with the school educational administration management system curriculum, which is easy to achieve automatic video release and archiving, forming a dynamic update of teaching resources.',
      },
    ],
  },
  // 双师课堂
  dualTeacher:{
    title:"REMOTE DUAL-TEACHER CLASSROOM CONSTRUCTION PROGRAM ",
    content:"At present, China is comprehensively promoting Internet+education mode, relying on the advantages of the Internet and other information technology, innovating school twinning support mechanism, and promoting the common construction and sharing of high-quality educational resources, to expand the radiation of high-quality educational resources, and realize the management of mutual aid schools, teaching and research, resource sharing, information sharing, teacher-student interaction, and complementary differences. At the mode, there are two teachers. One lecturer teacher teaches online, the other teacher manages students on site in the classroom on the listening side offline. This teaching mode gives full play to the advantages of both online and offline teachers and effectively improve the classroom efficiency and teaching quality, enabling students from different regions to enjoy the same quality education resources. Now, the remote dual-teacher classroom solution has been well received by schools and training institutions. ",
    componentsTitle:'PROGRAM COMPONENTS',
    components: [
      'smart blackboard',
      'normalized record and <br/> broadcasting equipment',
      'teacher’s <br/> cloud Mirror camera ',
      'student’s <br/> cloud Mirror camera ',
      '4k record and <br/> broadcasting<br/> equipment',
      'directional <br/> microphone ',
      'resource management <br/> platform',
    ],
    features_title:'FEATURES AND ADVANTAGES',
    featuresList:[
      {
        title:'Multi-point Interaction',
        name:'The system integrates multiple off-site classrooms into a teaching community, forming a cross-regional cloud classroom and achieving 1+N face-to-face online communication.',
      },
      {
        title:'Smooth HD Experience',
        name:'The remote dual-teacher classroom solution uses new audio and video coding technology and supports a variety of interactive protocols to ensure that the audio and video interaction is clear and smooth.',
      },
      {
        title:'Self-adapting to Complex Network',
        name:'It has advanced system algorithm, forward error correction(FEC) technology, frame loss compensation algorithm and Jitter buffering technology. Self-adaptive network and strong anti-packet loss capacity (more than 30%) guarantee low latency, clearness and smooth. And audio and video interaction effect is excellent. In the case of poor school network, the audio and video interaction can be carried out normally.',
      },
      {
        title:'Real-time Analysis of Dual-teacher Classroom Data',
        name:'Comprehensive analysis of global data, including the number of online users and new users, the number of class sessions, classroom information (packet loss records/network latency records/network bandwidth/CPU utilization rate), etc. The platform analyzes the acquired data and presents it in a clear chart, which is easy for users to visualize and control.',
      },
    ],
  },
  // AI 行为分析
  aiAnslysis:{
    title: "AI INTELLIGENT BEHAVIOR ANALYSIS MANAGEMENT PLATFORM ",
    content:"Wenxiang Behavior Analysis System supports artificial intelligence technology and it can automatically capture and analyze the behavior of teachers and students through the intelligent behavior analysis box , and automatically generate reports, such as: the number of hands raised and heads down, the proportion of emotion statistical analysis, etc., to analyze the behavior of classroom teachers and students, understand the status of students on learning. <br/> Through artificial intelligence and big data personalized and accurate analysis, the system can help the development of personalized teaching in schools. The basic information management of the school and student behavior related data are collected, and stored digitally, which provides important resources for the construction of intelligent school.",
    features_title:'FEATURES AND ADVANTAGES',
    featuresList: [
      {
        title: "support one-click import the curriculum",
        name:''
      },
      {
        title: "focus on the real-time teaching scene",
        name:''
      },
      {
        title: "various visual charts",
        name:''
      },
      {
        title: "intelligent statistical analysis",
        name:''
      },
      {
        title: "INTELLIGENT BEHAVIOR ANALYSIS BOX",
        name:''
      },
      {
        title: "Noiseless",
        name:'Embedded ARM architecture with fan-less design ensures no noise in use.'
      },
      {
        title: "Network Video Access",
        name:'Supports no less than 2 network video stream access to realize the real-time analysis of teachers and students.'
      },
      {
        title: "Support scene analysis",
        name:'Supports PTZ tour and it can be configured in the box to adapt to the scene analysis.'
      },
      {
        title: "Support Local Output",
        name:'HDMI supports local output to view the analysis screen and the screen marks real-time analysis results.'
      },
      {
        title: "Standard Interface",
        name:'Adopts 1 Mbps Ethernet port and standard HTTP interface can connect with the school information system.'
      },
      {
        title: "Safe Power Supply",
        name:'The box adopts 12V safe power supply.'
      }
    ],
  },
  // 便携录播
  portableRecord:{
    title:"PORTABLE RECORD AND BROADCASTING CONSTRUCTION PROGRAM",
    content:"The rapid development of the Internet, AI, big data, 5G and other technologies has brought significant impact on education and teaching. Wenxiang is actively applying new information technology to innovate teaching organization mode, improve learning environment, develop digital education resources, accelerate the construction and application of intelligent learning environment, enhance the innovative ability of informationized teaching, and promote the deep integration of information technology and teaching. Based on this, Wenxiang launched a portable record and broadcasting construction solution, which adopts full wireless transmission technology and can be set up in 3 minutes, so that recording and broadcasting can be truly mobile and no longer restricted by the site environment. It realizes high-quality course resource production and relay, academic video presentation and conference, large-scale live streaming of course video, and distance education, and etc.",
    componentsTitle:'PROGRAM COMPONENTS',
    components: [
      'portable record and <br/> broadcasting equipment',
      'cloud mirror camera',
      'monopod sets',
      'wireless omnidirectional mic',
      'public webcasting',
      'online vod',
    ],
    features_title:'FEATURES AND ADVANTAGES',
    featuresList:[
      {
        title:'3-minute Fast Installing',
        name:'Built-in embedded system can realize live streaming, on-demand and recording without plug-in. The whole installation of this system can be set up by simply selecting the location of the equipment and connecting the HD camera, portable record and broadcasting equipment, microphone and other accessories correctly. The whole system is easy to set up, which can be completed in 3 minutes, reducing the cumbersome operation steps and labor costs.',
      },
      {
        title:'Portable and Easy Anytime and Anywhere',
        name:'The portable recording system is designed for temporary recording situations, with simple structure and easy movement. There is no need to set up a fixed recording classroom and it greatly saves the cost of users and realizes recording be finished at anywhere and anytime. The whole set of equipment can be easily carried by one person with designed fight case, and it is easy to move and record without any restrictions on location.',
      },
      {
        title:'Guide Functions',
        name:'The guide function of the equipment is mainly used in the course of recording multiple scenes and multiple video signal sources, video/audio files and computer screen switching between. ',
      },
      {
        title:'Large Scale Live Streaming',
        name:'The device only needs to connect to the wireless network or mobile-phone hotspot. Then the program screen can be pushed to the whole network live streaming, and can automatically generate the live QR code, viewers can scan to watch the webcast. ',
      },
    ],
  },
  // 历届展会
  exhibitions:{
    "feature":[
      {
        img:'ISE-2024.png',
        info:`BUNKA exhibits at Europe's largest AV integration event, Integrated<br/>
        Systems Europe (ISE) , 30 Jan - 2 Feb 2024<br/>
        BUNKA is pleased to announce that it will be exhibiting at Europe's largest <br/>
        AV integration event, ISE 2024 - Integrated Systems Europe.<br/>
        We will present a wide range of products and systems, including recording <br/>
        and broadcasting equipment, intelligent blackboards and touch displays.<br/>
        We look forward to seeing you at our booth!<br/>
        Booth #4H530<br/>
        Invitation Code:6HSCBNVI<br/>
        For more information on ISE 2024, please visit<br/>
        https://www.iseurope.org/ise-2024-conference-programme`
      }
    ],
    "previous":[
      {
        img:'2023-6-19.png',
        info:'2023 China NorthEast Educational Equipment Expo',
        time:'2023/6/16-18'
      },
      {
        img:'2023-5-19_2.png',
        info:'The 3rd Sichuan Education Expo in 2023',
        time:'2023/6/19-21'
      },
      {
        img:'2023-5-19_1.png',
        info:'2023 Vocational Education Science and Technology Innovation Achievements and Digital Intelligence Training EquipmentTechnology Exhibition',
        time:'2023/5/19-21'
      },
      {
        img:'2023-5-12.png',
        info:'The 5th Henan Educational Equipment Expo',
        time:'2023/5/12-14'
      },
      {
        img:'2023-4-21.png',
        info:'The exclusive title of the 81st China Educational Equipment Exhibition',
        time:'2023/4/21-23'
      },
      {
        img:'2023-3-24.png',
        info:'The 21st Guangdong Education Equipment Exhibition',
        time:'2023/3/24-26'
      },
      {
        img:'2023-3-15.png',
        info:'2023 CHINA INTERNATIONAL EDUCATION EOUIPMENT(SHANGHAI) EXPO',
        time:'2023/3/15-17'
      },
    ]

  }

};



// WEBPACK FOOTER //
// ./src/langs/en.js